module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.b2f78d91.png";